import { apiClient } from '../client';
import type {
  BulkActivateResponse,
  BulkDeactivateResponse,
  BulkPublishResponse,
  CreateProductPayload,
  CreateProductResponse,
  ProductsListResponse,
  ProductShowResponse,
  ProductsListParams,
} from './types';

export const products = {
  list: (params?: ProductsListParams) =>
    apiClient.get<ProductsListResponse>('/api/products', { params }),

  get: (id: number) =>
    apiClient.get<ProductShowResponse>(`/api/products/${id}`),

  create: (data: CreateProductPayload) =>
    apiClient.post<CreateProductResponse>('/api/products', { product: data }),

  duplicate: (id: number) =>
    apiClient.post<ProductShowResponse>(`/api/products/${id}/duplicate`),

  activate: (id: number) =>
    apiClient.post<ProductShowResponse>(`/api/products/${id}/activate`),

  deactivate: (id: number) =>
    apiClient.post<ProductShowResponse>(`/api/products/${id}/deactivate`),

  publish: (id: number) =>
    apiClient.post<ProductShowResponse>(`/api/products/${id}/publish`),

  bulkPublish: (ids: number[]) =>
    apiClient.post<BulkPublishResponse>('/api/products/bulk_publish', { product_ids: ids }),

  bulkActivate: (ids: number[]) =>
    apiClient.post<BulkActivateResponse>('/api/products/bulk_activate', { product_ids: ids }),

  bulkDeactivate: (ids: number[]) =>
    apiClient.post<BulkDeactivateResponse>('/api/products/bulk_deactivate', { product_ids: ids }),
};
